import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { mgcIconAddRegular } from '@sb/mgc-icons/mgcIcon-add_regular.icon';

import { ButtonComponent } from '../button/button.component';
import { CardComponent } from '../card/card';
import { EmptyStateComponent, LoadingStateComponent } from '../feedback';
import { IconRegistry } from '../icon';
import { IconComponent } from '../icon/icon.component';
import { EmptySettings } from './dashboard-widget.model';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'sb-dashboard-widget',
  templateUrl: './dashboard.widget.component.html',
  imports: [
    ReactiveFormsModule,
    CardComponent,
    EmptyStateComponent,
    IconComponent,
    ButtonComponent,
    LoadingStateComponent,
  ],
})
export class DashboardWidgetComponent {
  title = input<string>();
  hasHeader = input<boolean>(true);
  fixedHeight = input<boolean>(true);
  isLoading = input<boolean>(false);
  isEmpty = input<boolean>(false);

  constructor() {
    inject(IconRegistry).registerIcons([mgcIconAddRegular]);
  }

  /**
   * Props for configuration the empty view
   */
  emptySettings = input<EmptySettings>();

  /**
   * Emits when the user clicks on the button in the empty state.
   */
  emptyAction = output<void>();
}
